// Settings-page CRUD shape for dbo.member_category. Distinct from
// MembershipCategory.tsx, which is the value-object snapshot attached to a
// loaded Member (no id, used in member-profile views). See FORT-156 for the
// eventual consolidation.
export interface MembershipCategoryRow {
    id: number;
    name: string;
    description: string | null;
    price: number;
    paymentFrequency: PaymentFrequency;
    isJointMembership: boolean;
    isVisible: boolean;
}

// Mirrors ClubBooking.Model.Payments.PaymentFrequency on the API. The C#
// enum serializes to its name (Monthly / Quarterly / SixMonths / Annual /
// OneTime) which is also what gets stored in dbo.member_category.payment_frequency.
export type PaymentFrequency = 'Monthly' | 'Quarterly' | 'SixMonths' | 'Annual' | 'OneTime';

export const PAYMENT_FREQUENCY_OPTIONS: ReadonlyArray<{ value: PaymentFrequency; label: string }> = [
    { value: 'Monthly', label: 'Monthly' },
    { value: 'Quarterly', label: 'Quarterly' },
    { value: 'SixMonths', label: 'Six Months' },
    { value: 'Annual', label: 'Annual' },
    { value: 'OneTime', label: 'One-off' },
];
